/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */
import { select } from 'redux-saga/effects';
import { callApiServiceCommon } from './service-common';

const reactAppApiDomain = process.env.REACT_APP_API_DOMAIN;
const commonServiceV2 = process.env.REACT_APP_API_COMMON_SERVICE_V2;

const blogApi = 'https://blog.autoketing.com/autoketingblog-posts';

const dashboardApi = process.env.REACT_APP_API_DOMAIN;

function getVal(str) {
  const v = window.location.search.match(new RegExp(`(?:[?&]${str}=)([^&]+)`));
  return v ? v[1] : undefined;
}

const shopUrl = getVal('shop');

export function* getSettingAppService({ shop }) {
  const payload = {
    method: 'GET',
    url: `${dashboardApi}tpi/get-setting-app-top-pin`,
    params: {
      shop_domain: shop
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getTopProductsViewedService({ shop }) {
  const payload = {
    method: 'GET',
    url: `${dashboardApi}tpi/get-product-top-view`,
    params: {
      shop_domain: shop
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getStatisticChartService(data) {
  const payload = {
    method: 'GET',
    url: `${dashboardApi}tpi/get-overview-statistic`,
    params: {
      shop_domain: data.shop,
      start_date: data.startDate,
      end_date: data.endDate
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getReportAppService({ shop }) {
  const payload = {
    method: 'GET',
    url: `${dashboardApi}tpi/get-count-data-top-pin`,
    params: {
      shop_domain: shop
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getSettingProductHistoryService({ shop }) {
  const payload = {
    method: 'GET',
    url: `${dashboardApi}tpi/get-setting-product-history`,
    params: {
      shop_domain: shop
    }
  };

  return yield callApiServiceCommon(payload);
}

export function* saveSettingProductHistoryService({ url }) {
  const historyData = yield select(state => state.get('productHistoryReducer'));
  const payload = {
    method: 'POST',
    url: `${dashboardApi}tpi/save-setting-product-history`,
    params: {
      shop_domain: window.shop_domain || shopUrl,
      status: historyData.get('status'),
      title: historyData.get('title'),
      max_products: historyData.get('maxProducts'),
      show_home_pages: historyData.get('showHomePages'),
      show_product_pages: historyData.get('showProductPages'),
      show_cart_pages: historyData.get('showCartPages'),
      show_collection_pages: historyData.get('showCollectionPages'),
      show_desktop: historyData.get('showDesktop'),
      show_mobile: historyData.get('showMobile'),
      bg_color: historyData.get('bgColor'),
      title_color: historyData.get('TitleColor'),
      remove_product_sold: historyData.get('removeProductSold'),
      bg_img_color: historyData.get('bgImgColor'),
      product_title_color: historyData.get('productTitleColor'),
      price_color: historyData.get('priceColor'),
      original_price_color: historyData.get('originalPriceColor'),
      settings: JSON.stringify(historyData.get('settings')),
      layout: historyData.get('layoutTheme'),
      url,
      slides_preview: historyData.get('slides_preview')
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getSettingTrendingProductService({ shop }) {
  const payload = {
    method: 'GET',
    url: `${dashboardApi}tpi/get-trending-product`,
    params: {
      shop_domain: shop
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* saveSettingTrendingProductService({ url }) {
  const trendingData = yield select(state => state.get('trendingProductReducer'));
  const payload = {
    method: 'POST',
    url: `${dashboardApi}tpi/save-trending-product`,
    params: {
      shop_domain: window.shop_domain || shopUrl,
      status: trendingData.get('status'),
      title: trendingData.get('title'),
      max_products: trendingData.get('maxProducts'),
      show_home_pages: trendingData.get('showHomePages'),
      show_product_pages: trendingData.get('showProductPages'),
      show_cart_pages: trendingData.get('showCartPages'),
      remove_product_sold: trendingData.get('removeProductSold'),
      show_collection_pages: trendingData.get('showCollectionPages'),
      show_desktop: trendingData.get('showDesktop'),
      show_mobile: trendingData.get('showMobile'),
      bg_color: trendingData.get('bgColor'),
      title_color: trendingData.get('TitleColor'),
      bg_img_color: trendingData.get('bgImgColor'),
      product_title_color: trendingData.get('productTitleColor'),
      price_color: trendingData.get('priceColor'),
      original_price_color: trendingData.get('originalPriceColor'),
      settings: JSON.stringify(trendingData.get('settings')),
      layout: trendingData.get('layoutTheme'),
      url,
      slides_preview: trendingData.get('slides_preview')
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getListProductsDetailService({ shop, ids, url }) {
  // console.log('=======ids========', ids.toString());
  // get products id
  const payload = {
    method: 'GET',
    url: `${dashboardApi}tpi/get-detail-product`,
    params: {
      shop_domain: shop,
      list_product: ids.toString(),
      url
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getSettingTopDiscountService({ shop }) {
  const payload = {
    method: 'GET',
    url: `${dashboardApi}tpi/get-setting-top-deal-product`,
    params: {
      shop_domain: shop
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* saveSettingTopDiscountService({ url }) {
  const topDiscountData = yield select(state => state.get('topDiscountReducer'));
  const payload = {
    method: 'POST',
    url: `${dashboardApi}tpi/save-setting-top-deal-product`,
    params: {
      shop_domain: window.shop_domain || shopUrl,
      status: topDiscountData.get('status'),
      title: topDiscountData.get('title'),
      list_products: JSON.stringify(topDiscountData.get('listProductsIds') || []),
      show_home_pages: topDiscountData.get('showHomePages'),
      show_product_pages: topDiscountData.get('showProductPages'),
      show_cart_pages: topDiscountData.get('showCartPages'),
      show_collection_pages: topDiscountData.get('showCollectionPages'),
      remove_product_sold: topDiscountData.get('removeProductSold'),
      show_desktop: topDiscountData.get('showDesktop'),
      show_mobile: topDiscountData.get('showMobile'),
      bg_color: topDiscountData.get('bgColor'),
      title_color: topDiscountData.get('TitleColor'),
      bg_img_color: topDiscountData.get('bgImgColor'),
      product_title_color: topDiscountData.get('productTitleColor'),
      price_color: topDiscountData.get('priceColor'),
      original_price_color: topDiscountData.get('originalPriceColor'),
      settings: JSON.stringify(topDiscountData.get('settings')),
      layout: topDiscountData.get('layoutTheme'),
      url,
      slides_preview: topDiscountData.get('slides_preview')
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getSettingBestSellingService({ shop }) {
  const payload = {
    method: 'GET',
    url: `${dashboardApi}tpi/get-setting-best-selling`,
    params: {
      shop_domain: shop
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* saveSettingBestSellingService({ url }) {
  const bestSellingData = yield select(state => state.get('bestSellingReducer'));
  const payload = {
    method: 'POST',
    url: `${dashboardApi}tpi/save-setting-best-selling`,
    params: {
      shop_domain: window.shop_domain || shopUrl,
      status: bestSellingData.get('status'),
      title: bestSellingData.get('title'),
      list_products: JSON.stringify(bestSellingData.get('listProductsIds') || []),
      show_home_pages: bestSellingData.get('showHomePages'),
      show_product_pages: bestSellingData.get('showProductPages'),
      show_cart_pages: bestSellingData.get('showCartPages'),
      show_collection_pages: bestSellingData.get('showCollectionPages'),
      show_desktop: bestSellingData.get('showDesktop'),
      remove_product_sold: bestSellingData.get('removeProductSold'),
      show_mobile: bestSellingData.get('showMobile'),
      bg_color: bestSellingData.get('bgColor'),
      title_color: bestSellingData.get('TitleColor'),
      bg_img_color: bestSellingData.get('bgImgColor'),
      product_title_color: bestSellingData.get('productTitleColor'),
      price_color: bestSellingData.get('priceColor'),
      original_price_color: bestSellingData.get('originalPriceColor'),
      settings: JSON.stringify(bestSellingData.get('settings')),
      layout: bestSellingData.get('layoutTheme'),
      url,
      slides_preview: bestSellingData.get('slides_preview')
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getSettingQuickViewService({ shop }) {
  const payload = {
    method: 'GET',
    url: `${dashboardApi}tpi/get-setting-quick-view`,
    params: {
      shop_domain: shop
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* saveSettingQuickViewService({ url }) {
  const quickViewData = yield select(state => state.get('quickViewReducer'));
  const payload = {
    method: 'POST',
    url: `${dashboardApi}tpi/setting-quick-view`,
    params: {
      shop_domain: window.shop_domain || shopUrl,
      qv_status: quickViewData.get('status'),
      qv_bg_color: quickViewData.get('qvBgColor'),
      qv_text_color: quickViewData.get('qvTextColor'),
      qv_text_price_color: quickViewData.get('qvTextPriceColor'),
      qv_bg_price_color: quickViewData.get('qvBgPriceColor'),

      add_to_cart_btn_text: quickViewData.get('addToCartBtnText'),
      added_to_cart_btn_text: quickViewData.get('addedToCartBtnText'),
      when_sold_out_btn_text: quickViewData.get('whenSoldOutBtnText'),
      add_to_cart_btn_bg_color: quickViewData.get('addToCartBtnBgColor'),
      add_to_cart_btn_text_color: quickViewData.get('addToCartBtnTextColor'),
      add_to_cart_btn_border_color: quickViewData.get('addToCartBtnBorderColor'),
      add_to_cart_hv_btn_bg_color: quickViewData.get('addToCartHvBtnBgColor'),
      add_to_cart_hv_btn_text_color: quickViewData.get('addToCartHvBtnTextColor'),
      add_to_cart_hv_btn_border_color: quickViewData.get('addToCartHvBtnBorderColor'),
      add_to_cart_loading_color: quickViewData.get('addToCartLoadingColor'),

      buy_now_btn_tex: quickViewData.get('buyNowBtnTex'),
      buy_now_when_sold_out_btn_text: quickViewData.get('buyNowWhenSoldOutBtnText'),
      buy_now_btn_bg_color: quickViewData.get('buyNowBtnBgColor'),
      buy_now_btn_text_color: quickViewData.get('buyNowBtnTextColor'),
      buy_now_btn_border_color: quickViewData.get('buyNowBtnBorderColor'),
      buy_now_btn_hv_bg_color: quickViewData.get('buyNowBtnHvBgColor'),
      buy_now_btn_hv_text_color: quickViewData.get('buyNowBtnHvTextColor'),
      buy_now_btn_hv_border_color: quickViewData.get('buyNowBtnHvBorderColor'),
      buy_now_loading_color: quickViewData.get('buyNowLoadingColor'),

      choose_detail_option: quickViewData.get('chooseDetailOption'),
      less_detail_title: quickViewData.get('lessDetailTitle'),
      full_detail_title: quickViewData.get('fullDetailTitle'),
      less_detail_color: quickViewData.get('lessDetailColor'),
      less_detail_hover_color: quickViewData.get('lessDetailHoverColor'),
      full_detail_hover_color: quickViewData.get('fullDetailHoverColor'),
      full_detail_color: quickViewData.get('fullDetailColor'),
      url
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getListBlogServer(number) {
  const payload = {
    method: 'GET',
    url: `${blogApi}`,
    params: {
      'post-per-page': number
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getPlanPackageSagaServer() {
  const apiUrl = `${reactAppApiDomain}tpi/get-current-package`;
  const payload = {
    method: 'POST',
    url: `${apiUrl}`,
    params: {}
  };
  return yield callApiServiceCommon(payload);
}

export function* upgradePlanPackageSagaServer(plan) {
  const apiUrl = `${reactAppApiDomain}tpi/register-charge`;
  const payload = {
    method: 'POST',
    url: `${apiUrl}`,
    params: {
      price_name: plan
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* buyMorePackageSagaServer({ count, shop, url }) {
  const apiUrl = `${reactAppApiDomain}pdc/buy-package`;
  const payload = {
    method: 'POST',
    url: `${apiUrl}`,
    params: {
      shop_domain: shop,
      count,
      url
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getDataShopInfoServer({ shop }) {
  const apiUrl = `${commonServiceV2}ak/get-shop-info`;
  const payload = {
    method: 'GET',
    url: `${apiUrl}`,
    params: {
      shop_domain: shop,
      app_code: 'tpi'
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* changeAppStatusService({ shop, url }) {
  const apiUrl = `${reactAppApiDomain}tpi/on-off-app`;
  const status_app = yield select(state => state.getIn(['appReducer', 'appStatus']));
  const payload = {
    method: 'POST',
    url: `${apiUrl}`,
    params: {
      shop_domain: shop,
      status_app,
      url
    }
  };
  return yield callApiServiceCommon(payload);
}
